import { DefaultSeoProps } from 'next-seo';
import metaData from './data/metadata.json';

export const getLocalizedDefaultSeo = (locale: string): DefaultSeoProps => {
  return {
    title: metaData.title[locale],
    description: metaData.description[locale],
    openGraph: {
      type: 'website',
      title: metaData.openGraph.title[locale],
      description: metaData.openGraph.description[locale],
      url: metaData.openGraph.url[locale],
      images: [
        {
          url: metaData.openGraph.image_url[locale],
          width: metaData.openGraph.image_width[locale],
          height: metaData.openGraph.image_height[locale],
        },
      ],
    },
  };
};
